// Enhanced Vendor Mock Data for Nartawi Admin
// Matches UI design requirements

export const vendorsData = [
  {
    id: "ID-145876",
    name: "Vendor A",
    companyName: "Vendor A Company",
    avatar: "/images/users/avatar-1.jpg",
    location: "Doha",
    verification: "Verified",
    orders: 130,
    revenueShare: "12%",
    rating: 4.5,
    status: "Active",
    contactPerson: "Ahmad Ali",
    email: "vendor.a@example.com",
    phone: "+974 1234 5678",
    zone: "Zone 1"
  },
  {
    id: "ID-145877",
    name: "Vendor B",
    companyName: "Vendor B Trading LLC",
    avatar: "/images/users/avatar-2.jpg",
    location: "Al Rayyan",
    verification: "Verified",
    orders: 95,
    revenueShare: "15%",
    rating: 4.2,
    status: "Active",
    contactPerson: "Mohammed Hassan",
    email: "vendor.b@example.com",
    phone: "+974 2345 6789",
    zone: "Zone 2"
  },
  {
    id: "ID-145878",
    name: "Vendor C",
    companyName: "Vendor C Enterprises",
    avatar: "/images/users/avatar-3.jpg",
    location: "Doha",
    verification: "Pending",
    orders: 67,
    revenueShare: "10%",
    rating: 3.8,
    status: "Active",
    contactPerson: "Ali Salem",
    email: "vendor.c@example.com",
    phone: "+974 3456 7890",
    zone: "Zone 1"
  },
  {
    id: "ID-145879",
    name: "Vendor D",
    companyName: "Vendor D Holdings",
    avatar: "/images/users/avatar-4.jpg",
    location: "Al Wakrah",
    verification: "Verified",
    orders: 142,
    revenueShare: "12%",
    rating: 4.7,
    status: "Active",
    contactPerson: "Khalid Ahmed",
    email: "vendor.d@example.com",
    phone: "+974 4567 8901",
    zone: "Zone 3"
  },
  {
    id: "ID-145880",
    name: "Vendor E",
    companyName: "Vendor E Store",
    avatar: "/images/users/avatar-5.jpg",
    location: "Doha",
    verification: "Not Verified",
    orders: 23,
    revenueShare: "8%",
    rating: 3.5,
    status: "In Active",
    contactPerson: "Fatima Abdullah",
    email: "vendor.e@example.com",
    phone: "+974 5678 9012",
    zone: "Zone 1"
  },
  {
    id: "ID-145881",
    name: "Vendor F",
    companyName: "Vendor F Markets",
    avatar: "/images/users/avatar-6.jpg",
    location: "Al Rayyan",
    verification: "Verified",
    orders: 108,
    revenueShare: "14%",
    rating: 4.4,
    status: "Active",
    contactPerson: "Sara Mahmoud",
    email: "vendor.f@example.com",
    phone: "+974 6789 0123",
    zone: "Zone 2"
  },
  {
    id: "ID-145882",
    name: "Vendor G",
    companyName: "Vendor G Services",
    avatar: "/images/users/avatar-7.jpg",
    location: "Doha",
    verification: "Verified",
    orders: 87,
    revenueShare: "11%",
    rating: 4.1,
    status: "Active",
    contactPerson: "Omar Ibrahim",
    email: "vendor.g@example.com",
    phone: "+974 7890 1234",
    zone: "Zone 1"
  },
  {
    id: "ID-145883",
    name: "Vendor H",
    companyName: "Vendor H Group",
    avatar: "/images/users/avatar-8.jpg",
    location: "Al Wakrah",
    verification: "Pending",
    orders: 45,
    revenueShare: "9%",
    rating: 3.9,
    status: "In Active",
    contactPerson: "Hassan Youssef",
    email: "vendor.h@example.com",
    phone: "+974 8901 2345",
    zone: "Zone 3"
  },
  {
    id: "ID-145884",
    name: "Vendor I",
    companyName: "Vendor I Trading",
    avatar: "/images/users/avatar-1.jpg",
    location: "Doha",
    verification: "Verified",
    orders: 156,
    revenueShare: "13%",
    rating: 4.6,
    status: "Active",
    contactPerson: "Nora Ahmed",
    email: "vendor.i@example.com",
    phone: "+974 9012 3456",
    zone: "Zone 1"
  },
  {
    id: "ID-145885",
    name: "Vendor J",
    companyName: "Vendor J Retail",
    avatar: "/images/users/avatar-2.jpg",
    location: "Al Rayyan",
    verification: "Verified",
    orders: 78,
    revenueShare: "10%",
    rating: 4.0,
    status: "Active",
    contactPerson: "Yousef Ali",
    email: "vendor.j@example.com",
    phone: "+974 0123 4567",
    zone: "Zone 2"
  },
  {
    id: "ID-145886",
    name: "Vendor K",
    companyName: "Vendor K Shop",
    avatar: "/images/users/avatar-3.jpg",
    location: "Doha",
    verification: "Not Verified",
    orders: 12,
    revenueShare: "7%",
    rating: 3.3,
    status: "In Active",
    contactPerson: "Layla Hassan",
    email: "vendor.k@example.com",
    phone: "+974 1234 5679",
    zone: "Zone 1"
  },
  {
    id: "ID-145887",
    name: "Vendor L",
    companyName: "Vendor L Commerce",
    avatar: "/images/users/avatar-4.jpg",
    location: "Al Wakrah",
    verification: "Verified",
    orders: 119,
    revenueShare: "12%",
    rating: 4.3,
    status: "Active",
    contactPerson: "Tariq Mohammed",
    email: "vendor.l@example.com",
    phone: "+974 2345 6780",
    zone: "Zone 3"
  },
  {
    id: "ID-145888",
    name: "Vendor M",
    companyName: "Vendor M Supplies",
    avatar: "/images/users/avatar-5.jpg",
    location: "Doha",
    verification: "Pending",
    orders: 34,
    revenueShare: "9%",
    rating: 3.7,
    status: "Active",
    contactPerson: "Mona Salem",
    email: "vendor.m@example.com",
    phone: "+974 3456 7891",
    zone: "Zone 1"
  },
  {
    id: "ID-145889",
    name: "Vendor N",
    companyName: "Vendor N Stores",
    avatar: "/images/users/avatar-6.jpg",
    location: "Al Rayyan",
    verification: "Verified",
    orders: 92,
    revenueShare: "11%",
    rating: 4.2,
    status: "Active",
    contactPerson: "Nasser Khalid",
    email: "vendor.n@example.com",
    phone: "+974 4567 8902",
    zone: "Zone 2"
  },
  {
    id: "ID-145890",
    name: "Vendor O",
    companyName: "Vendor O Mart",
    avatar: "/images/users/avatar-7.jpg",
    location: "Doha",
    verification: "Verified",
    orders: 103,
    revenueShare: "13%",
    rating: 4.4,
    status: "Active",
    contactPerson: "Rania Ahmed",
    email: "vendor.o@example.com",
    phone: "+974 5678 9013",
    zone: "Zone 1"
  },
  {
    id: "ID-145891",
    name: "Vendor P",
    companyName: "Vendor P Depot",
    avatar: "/images/users/avatar-8.jpg",
    location: "Al Wakrah",
    verification: "Not Verified",
    orders: 18,
    revenueShare: "8%",
    rating: 3.4,
    status: "In Active",
    contactPerson: "Saeed Omar",
    email: "vendor.p@example.com",
    phone: "+974 6789 0124",
    zone: "Zone 3"
  },
  {
    id: "ID-145892",
    name: "Vendor Q",
    companyName: "Vendor Q Express",
    avatar: "/images/users/avatar-1.jpg",
    location: "Doha",
    verification: "Verified",
    orders: 125,
    revenueShare: "14%",
    rating: 4.5,
    status: "Active",
    contactPerson: "Huda Mahmoud",
    email: "vendor.q@example.com",
    phone: "+974 7890 1235",
    zone: "Zone 1"
  },
  {
    id: "ID-145893",
    name: "Vendor R",
    companyName: "Vendor R Mall",
    avatar: "/images/users/avatar-2.jpg",
    location: "Al Rayyan",
    verification: "Verified",
    orders: 84,
    revenueShare: "10%",
    rating: 4.1,
    status: "Active",
    contactPerson: "Ibrahim Ali",
    email: "vendor.r@example.com",
    phone: "+974 8901 2346",
    zone: "Zone 2"
  },
  {
    id: "ID-145894",
    name: "Vendor S",
    companyName: "Vendor S Plaza",
    avatar: "/images/users/avatar-3.jpg",
    location: "Doha",
    verification: "Pending",
    orders: 56,
    revenueShare: "9%",
    rating: 3.8,
    status: "Active",
    contactPerson: "Amina Hassan",
    email: "vendor.s@example.com",
    phone: "+974 9012 3457",
    zone: "Zone 1"
  },
  {
    id: "ID-145895",
    name: "Vendor T",
    companyName: "Vendor T Center",
    avatar: "/images/users/avatar-4.jpg",
    location: "Al Wakrah",
    verification: "Verified",
    orders: 138,
    revenueShare: "12%",
    rating: 4.6,
    status: "Active",
    contactPerson: "Khalil Ahmed",
    email: "vendor.t@example.com",
    phone: "+974 0123 4568",
    zone: "Zone 3"
  }
]

// Vendor statistics
export const vendorStats = {
  totalVendors: 20,
  activeVendors: 14,
  inActiveVendors: 6,
  verifications: 14,
  zones: 7
}
